export default String.raw`
<div class="cp-menu-js">
	{% assign CPSections = settings.CPSections -%}
	{% for CPItem in CPSections -%}
		{% if CPItem.name == 'orders' -%}
			{% assign CPOrders = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'inquiries' -%}
			{% assign CPInquiries = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'offers' -%}
			{% assign CPOffers = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'invoices' -%}
			{% assign CPInvoices = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'sor' -%}
			{% assign CPSor = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'wm' -%}
			{% assign CPWm = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'complaints' -%}
			{% assign CPComplaints = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'customerDetails' -%}
			{% assign CPCustomerDetails = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'employees' -%}
			{% assign CPEmployees = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'yourAccount' -%}
			{% assign CPYourAccount = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'loyaltyProgram' -%}
			{% assign CPLoyaltyProgram = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'agreements' -%}
			{% assign CPAgreements = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'downloads' -%}
			{% assign CPDownloads = CPItem -%}
		{% endif -%}
		{% if CPItem.name == 'promotions' -%}
			{% assign CPPromotions = CPItem -%}
		{% endif -%}
	{% endfor -%}

	<div class="customer-container-menu">
		<ul class="category-column-js customer-profile-menu-js" data-container=".customer-profile-content-js" {% if page.PageId != config.DefinedPages.CustomerProfile.Id or page.QueryString contains 'wishlist' -%} style="border: none;" {% endif -%}>
			<li class="customer-container-menu__header" {% if page.PageId != config.DefinedPages.CustomerProfile.Id -%} style="display: none" {% endif -%}>{{ translations.CustomerPanel }}</li>
				<li class="email-container">
					<span>
						{{customer.Employee.Email}}
					</span>
				</li>
				{% if customer.CreditLimit -%}
				<li class="credit-info credit-info-js">
					<div class="data-container">
						<span class="data-container__name">{{translations.LimitGranted}}:</span>
						<span>{{customer.CreditLimit.Value}} {{customer.CurrencyExt}}</span>
					</div>
					{% if customer.CreditLimit.Active == true -%}
					<div class="data-container">
						<span class="data-container__name">{{ translations.CreditLeft }}</span>
						<span class="{% if customer.CreditLimit.Left > 0 -%} success {% endif -%} {% if customer.CreditLimit.Left < 0 -%} error {% endif -%}">
							{{customer.CreditLimit.Left}} {{ customer.CurrencyExt }}
						</span>
					</div>
					{% endif -%}
					{% if customer.CreditLimit.OverdueActive == true -%}
					<div class="data-container">
						<span class="data-container__name">{{ translations.OverduePayments }}</span>
						<span class="{% if customer.CreditLimit.OverdueUsed != 0 -%} error {% endif -%}">
							{{customer.CreditLimit.OverdueUsed}} {{ customer.CurrencyExt }}
						</span>
					</div>
					{% endif -%}
				</li>
				{% endif -%}
			{% if CPOrders.available -%}
				<li style="order: {{CPOrders.order}}">
					<button class="customer-container-menu__label load-erp-data-js {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=eshop-orders' or page.QueryString contains 'tab=active-orders' -%} active-js {% endif -%}" data-template="{{ CPOrders.dataTemplate }}">
						{% if CPOrders.icon != '' -%}
							<svg height="24" width="24" class="svgIcon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPOrders.icon}}-{{settings.iconStyle}}"></use>
							</svg>
						{% endif -%}
						{% if CPOrders.translation != '' -%}
							{{ translations[CPOrders.translation] }}
						{% else -%}
								{{ CPOrders.label }}
						{% endif -%}
					</button>
				</li>
			{% endif -%}
		{% if config.B2B and settings.inquiries == 'yes' -%}
			{% if CPInquiries.available -%}
				<li style="order: {{CPInquiries.order}}" >
					<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=inquiries' -%} active-js {% endif -%}" data-template="{{ CPInquiries.dataTemplate }}">
						{% if CPInquiries.icon != '' -%}
							<svg height="24" width="24" class="svgIcon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPInquiries.icon}}-{{settings.iconStyle}}"></use>
							</svg>
						{% endif -%}
						{% if CPInquiries.translation != '' -%}
							{{ translations[CPInquiries.translation] }}
						{% else -%}
							{{ CPInquiries.label }}
						{% endif -%}
					</button>
				</li>
			{% endif -%}
			{% if CPOffers.available -%}
				<li style="order: {{CPOffers.order}}">
					<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=offers' -%} active-js {% endif -%}" data-template="{{ CPOffers.dataTemplate }}">
						{% if CPOffers.icon != '' -%}
							<svg height="24" width="24" class="svgIcon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPOffers.icon}}-{{settings.iconStyle}}"></use>
							</svg>
						{% endif -%}
						{% if CPOffers.translation != '' -%}
							{{ translations[CPOffers.translation] }}
						{% else -%}
							{{ CPOffers.label }}
						{% endif -%}
					</button>
				</li>
			{% endif -%}
		{% endif -%}
		{% if settings.invoicesAvailability == 'yes' and config.B2B and CPInvoices.available -%}
			<li style="order: {{CPInvoices.order}}">
				<button class="customer-container-menu__label load-erp-data-js {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=invoices' -%} active-js {% endif -%}" data-template="{{ CPInvoices.dataTemplate }}">
					{% if CPInvoices.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPInvoices.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPInvoices.translation != '' -%}
						{{ translations[CPInvoices.translation] }}
					{% else -%}
						{{ CPInvoices.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if settings.SORAvailability == 'yes' and config.B2B and CPSor.available -%}
			<li style="order: {{CPSor.order}}">
				<button class="customer-container-menu__label load-erp-data-js {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=sor' -%} active-js {% endif -%}" data-template="{{ CPSor.dataTemplate }}">
					{% if CPSor.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPSor.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPSor.translation != '' -%}
						{{ translations[CPSor.translation] }}
					{% else -%}
						{{ CPSor.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if settings.WMAvailability == 'yes' and config.B2B and CPWm.available -%}
			<li style="order: {{CPWm.order}};">
				<button class="customer-container-menu__label load-erp-data-js {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=wm' -%} active-js {% endif -%}" data-template="{{ CPWm.dataTemplate }}">
					{% if CPWm.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPWm.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPWm.translation != '' -%}
						{{ translations[CPWm.translation] }}
					{% else -%}
						{{ CPWm.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if CPComplaints.available -%}
			<li style="order: {{CPComplaints.order}}">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=executed-complaints' or page.QueryString contains 'tab=active-complaints' -%} active-js {% endif -%}" data-template="{{ CPComplaints.dataTemplate }}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=active-complaints">
					{% if CPComplaints.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPComplaints.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPComplaints.translation != '' -%}
						{{ translations[CPComplaints.translation] }}
					{% else -%}
						{{ CPComplaints.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if CPCustomerDetails.available -%}
			<li style="order: {{CPCustomerDetails.order}}">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=customer-details' -%} active-js {% endif -%}" data-template="{{ CPCustomerDetails.dataTemplate }}">
					{% if CPCustomerDetails.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPCustomerDetails.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPCustomerDetails.translation != '' -%}
						{{ translations[CPCustomerDetails.translation] }}
					{% else -%}
						{{ CPCustomerDetails.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if CPEmployees.available -%}
			<li style="order: {{CPEmployees.order}}">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=employees-list' -%} active-js {% endif -%}" data-template="{{ CPEmployees.dataTemplate }}">
					{% if CPEmployees.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPEmployees.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPEmployees.translation != '' -%}
						{{ translations[CPEmployees.translation] }}
					{% else -%}
						{{ CPEmployees.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if CPYourAccount.available -%}
			<li style="order: {{CPYourAccount.order}}">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=your-account' -%} active-js {% endif -%}" data-template="{{ CPYourAccount.dataTemplate }}" data-include="account">
					{% if CPYourAccount.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPYourAccount.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPYourAccount.translation != '' -%}
						{{ translations[CPYourAccount.translation] }}
					{% else -%}
						{{ CPYourAccount.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if CPAgreements.available -%}
			<li style="order: {{CPAgreements.order}};">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=consents' -%} active-js {% endif -%}" data-template="{{ CPAgreements.dataTemplate }}">
					{% if CPAgreements.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPAgreements.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPAgreements.translation != '' -%}
						{{ translations[CPAgreements.translation] }}
					{% else -%}
						{{ CPAgreements.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if settings.downloadsAvailability == "yes" and config.B2B and CPDownloads.available -%}
			<li style="order: {{CPDownloads.order}};">
				<button class="customer-container-menu__label load-erp-data-js {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=to-download' -%} active-js {% endif -%}" data-template="{{ CPDownloads.dataTemplate }}">
					{% if CPDownloads.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPDownloads.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPDownloads.translation != '' -%}
						{{ translations[CPDownloads.translation] }}
					{% else -%}
						{{ CPDownloads.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if settings.couponsPresentation and CPPromotions.available -%}
			<li style="order: {{CPPromotions.order}};">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=discounts' or  page.QueryString contains 'tab=coupons' -%} active-js {% endif -%}" data-template="{{ CPPromotions.dataTemplate }}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=discounts">
					{% if CPPromotions.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPPromotions.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPPromotions.translation != '' -%}
						{{ translations[CPPromotions.translation] }}
					{% else -%}
						{{ CPPromotions.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if settings.loyaltyProgram == "yes" and CPLoyaltyProgram.available and usr.Authenticated -%}
			<li style="order: {{CPLoyaltyProgram.order}};">
				<button class="customer-container-menu__label {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%} scroll-top-js {% endif -%} {% if page.QueryString contains 'tab=loyalty-list' -%} active-js {% endif -%}" data-template="{{ CPLoyaltyProgram.dataTemplate }}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=loyalty-list">
					{% if CPLoyaltyProgram.icon != '' -%}
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{CPLoyaltyProgram.icon}}-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					{% if CPLoyaltyProgram.translation != '' -%}
						{{ translations[CPLoyaltyProgram.translation] }}
					{% else -%}
						{{ CPLoyaltyProgram.label }}
					{% endif -%}
				</button>
			</li>
		{% endif -%}
		{% if usr.Authenticated -%}
			<li style="order: 99;" class="customer-container-menu__logout form-js">
				<input type="hidden" name="__action" value="Customer/Logout" >
				<button class="sign-out-button sign-out-js">
					<svg height="24" width="24" class="svgIcon">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#sign-out-{{settings.iconStyle}}"></use>
					</svg>
					{{ translations.Logout }}
				</button>
			</li>
		{% endif -%}
		</ul>
	</div>
</div>
`